<div class="app-wrapper">
  <div [class.is-homepage]="isHomePage" [class.is-login-page]="isLoginPage">
    <app-header></app-header>
  </div>
  @if (isLoggedIn$ | async) {
    <app-sidebar></app-sidebar>
  }

  <div class="main-container">
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
    @if (!isLoginPage) {
      <app-footer></app-footer>
    }
  </div>
</div>